// extracted by mini-css-extract-plugin
module.exports = {"shape":"About_shape__192xX","morph":"About_morph__12tA7","smallTxt":"About_smallTxt__3NqiM","technology":"About_technology__21muG","btn":"About_btn__3wV-S"};